import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import InfoIconMDI from 'mdi-react/InformationOutlineIcon';

type PriceNoticeProps = {
  hideText?: boolean;
};

export const Text = styled.span(
  props => css`
    padding-left: ${layout.spacing.xxSmall};
  `
);

export const PriceNotice = styled.div<PriceNoticeProps>(
  props => css`
    display: flex;
    align-items: center;
    color: ${props.theme.icons.primary};

    ${props.hideText &&
      css`
        margin-right: ${layout.spacing.xSmall};

        ${media.smallOnly`
          margin-right: 2px;
        `}

        ${Text} {
          display: none;
        }
      `};
  `
);

export const InfoIcon = styled(InfoIconMDI)(
  props => css`
    color: ${props.theme.icons.quaternary};
  `
);
